import { render, staticRenderFns } from "./cate-box.vue?vue&type=template&id=2321d706&scoped=true"
import script from "./cate-box.vue?vue&type=script&lang=js"
export * from "./cate-box.vue?vue&type=script&lang=js"
import style0 from "./cate-box.vue?vue&type=style&index=0&id=2321d706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2321d706",
  null
  
)

export default component.exports